import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/app/common/common-components/ui/Dialog";
import { WhatsAppIcon } from "@/app/common/common-components/BrandIcons";
import { Mail, MessageCircle } from "lucide-react";
import { ContactMessageModel } from "@/app/models/ContactMessageModel";
import { getMessageType } from "@/app/common/common-functions/functions";

interface PreviewMessageDialogProps {
  message: ContactMessageModel | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const PreviewMessageDialog = ({
  message,
  open,
  onOpenChange,
}: PreviewMessageDialogProps) => {
  if (!message) return null;

  const getIcon = (type?: string) => {
    switch (type) {
      case "Whatsapp":
        return <WhatsAppIcon className="tw-size-5 tw-fill-primary" />;
      case "SMS":
        return <MessageCircle className="tw-size-5 tw-text-primary" />;
      case "Email":
        return <Mail className="tw-size-5 tw-text-primary" />;
      default:
        return null;
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw-max-w-2xl">
        <DialogHeader>
          <DialogTitle className="tw-flex tw-items-center tw-gap-2">
            {getIcon(getMessageType(message.type))}
            <span>{getMessageType(message.type)} Message</span>
          </DialogTitle>
        </DialogHeader>
        <span>Date: {message.dateOn}</span>
        {getMessageType(message.type) === "Email" ? (
          <div
            className="tw-bg-muted/50 tw-rounded-lg tw-border tw-border-border tw-p-4 tw-text-sm"
            dangerouslySetInnerHTML={{ __html: message.message }}
          />
        ) : (
          <div className="tw-bg-muted/50 tw-rounded-lg tw-border tw-border-border tw-p-4 tw-text-sm">
            {message.message}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PreviewMessageDialog;
